import AuthRoute from "shared/routes/authRoute";
import Toast from "shared/components/common/toast";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import "tippy.js/dist/tippy.css";
import "shared/utils/theme.scss";
import "./App.scss";
import { useEffect } from "react";
import { useSelector } from "react-redux";

function App() {
  const {
    theme: { theme },
  } = useSelector((state: any) => state?.root);
  useEffect(() => {
    document.documentElement.setAttribute("theme-mode", theme);
  }, [theme]);
  return (
    <div className="App">
      <AuthRoute />
      <Toast />
    </div>
  );
}

export default App;
